import * as XLSX from 'xlsx';
import { useState } from 'react';


const ExportExcelRackProductBtn = ({ data, headers, fileName}) => {
    const [isExporting, setIsExporting] = useState(false)

    const exportToExcel = () => {
        try {
            setIsExporting(true)
            const excelData = [
                [`${fileName.toUpperCase()}`]
            ]
            excelData.push([], headers, ...data)
            const ws = XLSX.utils.aoa_to_sheet(excelData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
            XLSX.writeFile(wb, `${fileName}.xlsx`);
        } catch (error) {
            console.log("error", error)
        }
        setIsExporting(false)
    }

    return (
        <div>
            {data.length ? (
                <button className='btn btn-success' disabled={isExporting} onClick={exportToExcel}>
                    {isExporting ? "Exporting ..." : "Export"}
                    <i className="fa-solid fa-file-excel ms-2"></i>
                </button>
            ) : null}
        </div>
    );
};

export default ExportExcelRackProductBtn

